import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import { openNewTab } from 'helpers/domHelper';
import { useEventHandler } from 'hook/event.hook';
import { useSeenModulePixel } from 'hook/helper.hook';

// images
import IconGuide from 'style/icons/icon-guide.svg';

import './CollectionGuideBanner.scss';

function CollectionGuideBanner({
  className,
  numberOfAccounts,
  url = 'https://smart.link/rbfe5mo56ankf',
  addVisibilityTracking = false,
  trackingPageName = '',
  module = 'COLLECTIONS_GUIDE',
}) {
  const eventHandler = useEventHandler();

  const onClickOpenApp = e => {
    e.preventDefault(); // add this prevent default to register mixpanel event
    eventHandler(CLICK, {
      'Click Type': 'Download Collections Guide',
      'Module Name': module,
    });
    openNewTab(url);
  };

  const collectionText =
    numberOfAccounts === 1 ? '1 collection' : `${numberOfAccounts} collections`;

  const seenPixel = useSeenModulePixel({
    'Page Name': trackingPageName,
    'Module Name': module,
  });

  return (
    <>
      {addVisibilityTracking && seenPixel}
      <div
        className={classnames(
          'flex-container',
          'align-items-center',
          'padtb6',
          'padlr8',
          'bgYellow050',
          'column-gap-4',
          className,
        )}
        onClick={onClickOpenApp}
      >
        <img
          className="collectionGuideBannerImage"
          src={IconGuide}
          alt="checklist board"
        />
        <span className="text-14 lineHeight-1-5" tabIndex={0}>
          Get a free guide to help you deal with your <br />
          {collectionText} in our app{' '}
          <span className="fontBlue100">Download app now</span>.
        </span>
      </div>
    </>
  );
}

CollectionGuideBanner.propTypes = {
  className: PropTypes.string,
  numberOfAccounts: PropTypes.number,
  url: PropTypes.string,
  addVisibilityTracking: PropTypes.bool,
  trackingPageName: PropTypes.string,
};

export default CollectionGuideBanner;
